import SearchIcon from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../redux/hooks';
import { setFilters } from '../../../redux/slices/protocolSlice';

const Search = () => {
  const dispatch = useAppDispatch();
  const [searchValue, setSearchValue] = useState('');

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(setFilters({ search: searchValue }));
    }, 500);

    return () => clearTimeout(timer);
  }, [searchValue, dispatch]);

  return (
    <Box
      sx={{
        flex: 1,
        maxWidth: { xs: '100%', sm: 400 },
        // border: '1px solid',
        // borderColor: 'divider',
        // borderRadius: 1,
        overflow: 'hidden',
      }}
    >
      <TextField
        fullWidth
        placeholder='Buscar protocolos...'
        value={searchValue}
        onChange={e => setSearchValue(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        size='small'
        // variant='outlined'
        // sx={{
        //   '& .MuiOutlinedInput-root': {
        //     border: 'none !important',
        //     '& fieldset': {
        //       border: 'none !important',
        //       borderWidth: '0 !important',
        //       borderColor: 'transparent !important',
        //     },
        //     '&:hover fieldset': {
        //       border: 'none !important',
        //       borderWidth: '0 !important',
        //       borderColor: 'transparent !important',
        //     },
        //     '&.Mui-focused fieldset': {
        //       border: 'none !important',
        //       borderWidth: '0 !important',
        //       borderColor: 'transparent !important',
        //     },
        //     '&.Mui-focused': {
        //       outline: 'none !important',
        //       boxShadow: 'none !important',
        //       border: 'none !important',
        //     },
        //     '&:hover': {
        //       border: 'none !important',
        //     },
        //   },
        //   '& .MuiOutlinedInput-input': {
        //     '&:focus': {
        //       outline: 'none !important',
        //     },
        //   },
        // }}
      />
    </Box>
  );
};

export default Search;
